import { useContext, useState } from 'react'
import NextLink from 'next/link'
import { Box, Divider, Icon, Flex, Text, Tooltip, Link, Badge, Button, IconButton } from '@chakra-ui/react'
import { ArrowLeftCircleIcon, ArrowRightCircleIcon, FunnelIcon, UserGroupIcon, MagnifyingGlassIcon, PresentationChartLineIcon, SpeakerWaveIcon, UsersIcon } from '@heroicons/react/24/outline'

const intelligenceItems = [
    { name: 'SEO', icon: MagnifyingGlassIcon, IsDisable: true, href: ''},
    { name: 'Forums', icon: UserGroupIcon, IsDisable: true, href: ''},
    { name: 'Social Media', icon: UsersIcon, IsDisable: true, href: '' },
]

const planningItems = [
    { name: 'Funnels', icon: FunnelIcon, IsDisable: false, href: '/' },
    { name: 'Ads', icon: SpeakerWaveIcon, IsDisable: false, href: '/ads' },
    // { name: 'Outreach', icon: UserIcon, IsDisable: true },
    // { name: 'Content', icon: DocumentTextIcon, IsDisable: true },
    { name: 'Forecast', icon: PresentationChartLineIcon, IsDisable: false, href: '/forecasts' },
]

export default function SimpleSidebar() {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <Box
            bg='white'
            borderRight="1px"
            borderRightColor='gray.200'
            w={isOpen ? 80 : 20 }
            h="full"
            display='flex'
            flexDirection='column'
        >
            {isOpen &&
                <Flex alignItems="center" mt="30px" mb="10px" mx="8">
                    <Text bg={"purple.100"} borderRadius={"5px"} padding={"8px"} ml={'4px'} fontSize="16px" fontFamily="monospace" whiteSpace='nowrap' fontWeight="bold">
                        Pretty Funnels
                    </Text>
                </Flex>
            }
            <Flex mt={!isOpen ? 'auto': 'none'}  flexDirection={'column'}>
                {isOpen && <Text p="4" mx="4" fontWeight={'bold'} fontSize={'xl'}>Intelligence <Badge ml='1' colorScheme='purple'>Soon</Badge></Text>}
                {intelligenceItems.map((link) => (
                    <NavItem key={link.name} icon={link.icon} name={link.name} isOpen={isOpen} IsDisable={link.IsDisable} href={link.href}/>
                ))}
                {!isOpen && <Divider />}
                {isOpen && <Text align="start" p="4" mx="4" fontWeight={'bold'} fontSize={'xl'}>Planning</Text>}
                {planningItems.map((link) => (
                    <NavItem key={link.name} icon={link.icon} name={link.name} isOpen={isOpen} href={link.href} />
                ))}
            </Flex>
            <NavItem mt='auto' mb="20px" onClick={() => setIsOpen(o => !o)} isOpen={isOpen} icon={isOpen ? ArrowLeftCircleIcon : ArrowRightCircleIcon} name={isOpen ? "Collapse" : "Expand"} />
        </Box>
    )
}

const NavItem = ({ icon, children, isOpen, name, IsDisable, href, ...rest }) => {
    return (
        <Tooltip placement={'start'} hasArrow label={name} display={isOpen && 'none'}>
            <Link
                href={href} 
                as={href && NextLink}
                disabled={IsDisable}
                display="flex"
                _hover={{ bg: 'purple.500', color: 'white' }}
                _focus={{ boxShadow: 'none' }}
                _disabled={{ color: 'blackAlpha.600', bg: 'none', cursor: 'not-allowed' }}
                alignItems="center"
                p={isOpen ? "2" : "4"}
                mx="4"
                borderRadius="lg"
                {...rest}>
                <Icon fontSize="16" as={icon} />
                {isOpen && <Text ml="4" as={'span'}>{name}</Text>}
            </Link>
        </Tooltip>
    )
}
